exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".editKhachHang-container .ant-tabs-tab.ant-tabs-tab-active {\n  background: none;\n}", "",{"version":3,"sources":["EditKhachHang.scss"],"names":[],"mappings":"AACC;EACC,gBAAA;AAAF","file":"EditKhachHang.scss","sourcesContent":[".editKhachHang-container {\r\n\t.ant-tabs-tab.ant-tabs-tab-active {\r\n\t\tbackground: none\r\n\t}\r\n}"]}]);

